import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";

import AutoComplete from "antd/es/auto-complete";
import Input from "antd/es/input";
import { CaretDownOutlined, SearchOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { api } from "@redux/api";

import styled from "styled-components";
import { Button, Drawer, Empty } from "antd";

export const ScenarioLookupWrapper = styled.div`
  .ant-select-auto-complete {
    .ant-input-affix-wrapper {
      border-radius: 6px;
      transition: border-color 0.2s ease;
    }
  }

  .scenario-mobile-trigger {
    width: 100%;
    min-height: 40px;
    border: 1px solid #d9d9d9;
    border-radius: 8px;
    padding: 0 12px;
    background: #fff;
    color: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: left;
  }

  .scenario-mobile-trigger-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .scenario-mobile-trigger-placeholder {
    color: #8c8c8c;
  }
`;

class ScenarioLookup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      selected: null,
      drawerOpen: false,
      search: "",
    };
  }

  handleEdit = (data) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleEdit(data);
    
  };

  handleDelete = (id) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.handleDelete(id);
  };

  buildOptions = (data) => {
    const { canWrite, canFullAccess } = this.props;
    return data.map((item) => {
      const isPublic = item.public;
      const showEdit = !isPublic || canWrite;
      const showDelete = !isPublic || canFullAccess;
      return {
        label: (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {item.name}
            <span style={{ display: 'flex', gap: 4 }}>
              {showEdit && (
                <Button
                  type="text"
                  size="small"
                  icon={<EditOutlined />}
                  onClick={this.handleEdit(item)}
                  style={{ color: '#8c8c8c' }}
                />
              )}
              {showDelete && (
                <Button
                  type="text"
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={this.handleDelete(item.id)}
                />
              )}
            </span>
          </div>
        ),
        value: item.name,
        id: item.id,
        record: item,
      };
    });
  };

  handleFocus = async (e) => {
    const result = await api.filterScenario("");
    const data = _.get(result, "data.results", []);
    this.setState({ options: this.buildOptions(data) });
  };

  handleSearch = async (e) => {
    const result = await api.filterScenario("issue=" + e);
    const data = _.get(result, "data.results", []);
    this.setState({ options: this.buildOptions(data) });
  };

  handleSelect = (e, record) => {
    this.setState({
      selected: record.record,
      Scenario: e,
      drawerOpen: false,
    });

    this.props.SelectedScenario(record);
  };

  openMobileDrawer = async () => {
    this.setState({ drawerOpen: true, search: "" });
    await this.handleFocus();
  };

  openScenario = (e, isNewScenario) => {
    this.setState({
      visible: true,
      isNewScenario,
      drawerOpen: false,
    });
    this.props.handleOpenScenario(true, isNewScenario);
  };

  render() {
    const isH5 = this.props.isPC === false;
    if (isH5) {
      const selectedName = this.state.selected?.name || this.props.value;
      return (
        <ScenarioLookupWrapper>
          <button
            type="button"
            className="scenario-mobile-trigger"
            onClick={this.openMobileDrawer}
          >
            <span className={`scenario-mobile-trigger-label${selectedName ? "" : " scenario-mobile-trigger-placeholder"}`}>
              {selectedName || "Select a Scenario"}
            </span>
            <CaretDownOutlined style={{ color: "#8c8c8c", marginLeft: 8 }} />
          </button>
          <Drawer
            visible={this.state.drawerOpen}
            open={this.state.drawerOpen}
            title="Select Scenario"
            placement="bottom"
            height="72vh"
            className="scenario-lookup-mobile-drawer"
            onClose={() => this.setState({ drawerOpen: false })}
            destroyOnClose
          >
            <div className="scenario-lookup-mobile-body">
              <Input
                allowClear
                className="scenario-lookup-mobile-search"
                placeholder="Search scenario"
                prefix={<SearchOutlined style={{ color: "var(--color-primary, #4482FF)" }} />}
                value={this.state.search}
                onChange={(event) => {
                  const value = event.target.value;
                  this.setState({ search: value });
                  this.handleSearch(value);
                }}
              />
              <div className="scenario-lookup-mobile-list">
                {this.state.options.length === 0 ? (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No Scenario Found" />
                ) : (
                  this.state.options.map((option) => {
                    const record = option.record;
                    const isPublic = record.public;
                    const showEdit = !isPublic || this.props.canWrite;
                    const showDelete = !isPublic || this.props.canFullAccess;
                    return (
                      <button
                        type="button"
                        key={record.id}
                        className="scenario-lookup-mobile-option"
                        onClick={() => this.handleSelect(record.name, option)}
                      >
                        <span className="scenario-lookup-mobile-option-name">{record.name}</span>
                        <span className="scenario-lookup-mobile-option-actions" onClick={(event) => event.stopPropagation()}>
                          {showEdit && (
                            <Button
                              type="text"
                              size="small"
                              icon={<EditOutlined />}
                              onClick={this.handleEdit(record)}
                            />
                          )}
                          {showDelete && (
                            <Button
                              type="text"
                              size="small"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={this.handleDelete(record.id)}
                            />
                          )}
                        </span>
                      </button>
                    );
                  })
                )}
              </div>
              {this.props.canWrite ? (
                <Button
                  type="dashed"
                  icon={<PlusOutlined />}
                  className="scenario-lookup-mobile-new"
                  onClick={(event) => this.openScenario(event, true)}
                >
                  New Scenario
                </Button>
              ) : null}
            </div>
          </Drawer>
        </ScenarioLookupWrapper>
      );
    }

    return (
      <ScenarioLookupWrapper>
        <AutoComplete
          style={{ width: "280px" }}
          options={this.state.options}
          onFocus={this.handleFocus}
          onSelect={this.handleSelect}
          onSearch={this.handleSearch}
          value={this.props.value}
          dropdownMatchSelectWidth={false}
          notFoundContent={() => {
            return <div style={{ padding: '12px', textAlign: 'center', color: '#8c8c8c' }}>No Scenario Found</div>;
          }}
          dropdownRender={(menu) => (
            <div>
              {menu}
              <div style={{ borderTop: '1px solid #f0f0f0', padding: '8px', display: 'flex', justifyContent: 'center' }}>
                <Button
                  type="dashed"
                  size="small"
                  icon={<PlusOutlined />}
                  onClick={(e) => this.openScenario(e, true)}
                  style={{ width: '90%' }}
                >
                  New Scenario
                </Button>
              </div>
            </div>
          )}
        >
          <Input
            size="medium"
            allowClear
            placeholder="Select a Scenario"
            autoComplete="off"
            prefix={<SearchOutlined style={{ color: 'var(--color-primary, #4482FF)' }} />}
            suffix={<CaretDownOutlined style={{ color: '#bfbfbf' }} />}
          />
        </AutoComplete>
      </ScenarioLookupWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isPC: state.App?.isPC,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioLookup);
